import { render, staticRenderFns } from "./DepositsBreadcrumbButton.component.vue?vue&type=template&id=9c37e50c&scoped=true&"
import script from "./DepositsBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./DepositsBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositsBreadcrumbButton.component.vue?vue&type=style&index=0&id=9c37e50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c37e50c",
  null
  
)

export default component.exports